import domain from '../../constants/Opus';

export const rootUrl = domain.HIPAGES_URL;
